import { useId, type FC, type ReactNode } from 'react';
import { cn } from '../lib/utils';

interface ChatSectionProps {
  /** Eyebrow label, e.g. `Summary`. Rendered uppercase. */
  title: string;
  /** Right-aligned note, e.g. `updated 2m ago`. */
  meta?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** A labelled block in the Assistant's overview column. */
export const ChatSection: FC<ChatSectionProps> = ({
  title,
  meta,
  children,
  className
}) => {
  const headingId = useId();

  return (
    <section
      aria-labelledby={headingId}
      className={cn('flex flex-col gap-2.5', className)}
    >
      <div className="flex items-center justify-between gap-3">
        <h3
          id={headingId}
          className="text-eyebrow tracking-[0.12em] text-muted-foreground uppercase"
        >
          {title}
        </h3>
        {meta ? <span className="text-caption text-muted-foreground">{meta}</span> : null}
      </div>
      {children}
    </section>
  );
};
